"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "36", height: "36", viewBox: "0 0 36 36", className: "Icon toolbar-h1", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "g",
            { fill: "none", fillRule: "evenodd" },
            _react2.default.createElement("rect", { stroke: "#BBB", x: ".5", y: ".5", width: "35", height: "35", rx: "3" }),
            _react2.default.createElement("path", { d: "M16.896 21.456c0 .944-.48 1.12-1.52 1.152v.768h5.072v-.768c-1.072-.032-1.52-.208-1.52-1.152v-7.408c0-.928.448-1.104 1.52-1.136v-.768h-5.072v.768c1.04.032 1.52.208 1.52 1.136v3.136h-5.344v-3.136c0-.928.48-1.104 1.52-1.136v-.768H8v.768c1.072.032 1.52.208 1.52 1.136v7.408c0 .944-.448 1.12-1.52 1.152v.768h5.072v-.768c-1.04-.032-1.52-.208-1.52-1.152v-3.408h5.344v3.408zM25.2 12c-.832 1.104-1.52 1.52-3.072 1.744l-.512.08v.656h2.112v6.96c0 .976-.384 1.04-2.112 1.152v.784h6.112v-.784c-1.664-.096-2.016-.176-2.016-1.152V12H25.2z", fill: "#4C4C4C" })
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/large/jsx/toolbar-h1.js
// module id = 1839
// module chunks = 0